
// data.service.ts
import { Injectable } from '@angular/core';
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';

@Injectable()
export class ChartOfAccountsService {
      //selectedChartOfAccount:any;
      accountStatusList: any[] = [];
      accountTypeList: any[] = [];
      parentAccountList: any[] = [];
      sharedData: any; // This variable will store the shared data
      TransportModeTypeList: any[] = [];
      transportList: any[] = [];
      EntityStatusList: any[] = [];
      driverStatusTypeList: any[] = [];
      CompanyList: any[] = [];
      AccountingYearList: any[] = [];

      selectedCourierItemList: any[] = [];
      UserId: any;

      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal,
            private cookieservice: CookieService,
            private decryptpipe: DecryptPipe) { }

      setItemList(list: any[]) {
            this.selectedCourierItemList = list;
      }

      getItemList() {
            return this.selectedCourierItemList;
      }

      deleteAccountById(Id): Promise<any> {
            this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("UserId")));
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: 'Are you sure you want to delete this chart of account?',
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService.GetByTwoId("ChartsofAccount", "DeleteAccount", Id, this.UserId).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    this.toastr.success(
                                          "Detail Deleted Successfully !",
                                          "Success"
                                    );
                                    resolve(1);
                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            })

      }

      getAccountTypeList() {
            return this.accountTypeList = [{ value: 1, name: 'Is Group' }, { value: 2, name: 'Is Ledger' }]
      }
      GetAccountStatus() {
            return this.accountStatusList = [{ value: null, name: 'All' }, { value: 1, name: 'Active' }, { value: 0, name: 'InActive' }]
      }

      // getParentAccountList() {
      //       return new Promise((resolve, reject) => {
      //             this._appService
      //                   .GetParentAccounts("ChartsofAccount", "GetParentAccounts", '%%', 1)
      //                   .subscribe(
      //                         (response) => {
      //                               console.log(response);
      //                               if (response.Results.length > 0) {
      //                                     response.Results.map(x => {
      //                                           x.name = x.text;
      //                                           x.value = x.id;
      //                                     })
      //                               }
      //                               this.parentAccountList = response.Results;
      //                               resolve(response.Results);
      //                         },
      //                         (err) => {
      //                               this.toastr.error(
      //                                     "Error occurred while fetching Parent Account List !",
      //                                     "error"
      //                               );
      //                               reject(err);

      //                         }
      //                   );
      //       });
      // }
      getParentAccountList(param, pageNo): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetParentAccounts("ChartsofAccount", "GetParentAccounts", param, pageNo)
                        .subscribe(
                              (response) => {
                                    console.log(response);
                                    if (response.Results.length > 0) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    this.parentAccountList = response.Results;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Parent Account List !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      getDriverList(param, pageNo): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetParentAccounts("ChartsofAccount", "GetParentAccounts", param, pageNo)
                        .subscribe(
                              (response) => {
                                    console.log(response);
                                    if (response) {
                                          response.Results.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Driver type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            })
      }

      //added by vithujan 05-12-2023 - Siddarth
      GetUserCompany(TenantId: any): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .GetById("Company", "GetUserCompany", TenantId)
                        .subscribe(
                              (response) => {
                                    if (response.data) {
                                          response.data.map(x => {
                                                x.name = x.Label;
                                                x.value = x.Id;
                                          })
                                    }
                                    this.CompanyList = response.data;
                                    resolve(response.data);
                              },
                              (err) => {
                                    var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
                                    this.toastr.error(OwnershipError, "error");
                              }
                        );
            });
      }

      //add by maaria on 15-01-2024
      GetAccountingYear(): Promise<any> {
            return new Promise((resolve) => {
                  this._appService
                        .Get("Common", "GetAccountingYear")
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.text;
                                                x.value = x.id;
                                          })
                                    }
                                    resolve(response);
                              },
                              (err) => {
                                    var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
                                    this.toastr.error(OwnershipError, "error");
                              }
                        );
            });

      }

      //end

      //add edit related methods
      Account: any = [];
      GetAccounttypedata() {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByTwoId("ManageTDS", "NewGetAccountListforTDS", '%%', 1)
                        .subscribe(
                              (response) => {
                                    console.log(response);
                                    if (response.length > 0) {
                                          response.map(x => {
                                                x.name = x.Name;
                                                x.value = x.AccountId;
                                          })
                                    }
                                    this.Account = response
                                    this.Account = { ...this.Account, dropdownList: response };
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while AccountType  data!",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      GetSalesReceiptAccountTypeforTDS(Id) {
            return new Promise((resolve, reject) => {
                  this._appService.GetByTwoId("ChartsofAccount", "GetSalesReceiptAccountTypeforTDS", Id, '%%').subscribe((response) => {
                        if (response.length > 0) {
                              response.map(x => {
                                    x.name = x.text;
                                    x.value = x.id;
                              })
                        }
                        resolve(response);
                  },
                        (err) => {
                              this.toastr.error(err._body.replace(/"/g, ""), "error");
                              reject(err);

                        }
                  );
            });
      }

      GetPurchaseBillPaymentsAccountTypeTDS(Id) {
            return new Promise((resolve, reject) => {
                  this._appService.GetByTwoId("ChartsofAccount", "GetPurchaseBillPaymentsAccountTypeTDS", Id, '%%').subscribe((response) => {
                        if (response.length > 0) {
                              response.map(x => {
                                    x.name = x.text;
                                    x.value = x.id;
                              })
                        }
                        resolve(response);
                  },
                        (err) => {
                              this.toastr.error(err._body.replace(/"/g, ""), "error");
                              reject(err);

                        }
                  );
            });
      }

      GetAccountList(query): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .GetByQueryPage("JournalEntry", "GetAccountListNew", query, 1)
                        .subscribe(
                              (response) => {
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.Name;
                                                x.value = x.AccountId;
                                          })
                                    }
                                    resolve(response);
                                    return response;
                              },
                              (err) => {
                                    var OwnershipError = this.translate.instant("READYTODISPATCH.Erroroccurred");
                                    this.toastr.error(OwnershipError, "error");
                                    reject(err);
                              }
                        );
            })
      }
}
